import { render } from "./CatalogProductsOverviewTableItem.vue?vue&type=template&id=ddee8b70&scoped=true&ts=true"
import script from "./CatalogProductsOverviewTableItem.vue?vue&type=script&lang=ts"
export * from "./CatalogProductsOverviewTableItem.vue?vue&type=script&lang=ts"

import "./CatalogProductsOverviewTableItem.vue?vue&type=style&index=0&id=ddee8b70&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddee8b70"]])

export default __exports__